import React from "react";
import { modalOverrides, sponsorModal, textModal } from "./common";
export default [
    {
        width: "9.4%",
        height: "13%",
        left: "82.6%",
        top: "33%",
        label: "IBM - Contact Us",
        onClick: function () {
            document.getElementById("IBM").click();
        }
    },
    {
        width: "10%",
        height: "13%",
        left: "82.6%",
        top: "48%",
        label: "IBM - Play Content",
        modalOverrides: modalOverrides,
        modal: React.createElement("div", { style: { height: "100%", width: "100%" } },
            React.createElement("iframe", { width: "100%", height: "100%", frameBorder: "0", src: "https://player.vimeo.com/video/768519590?h=78374cbe28&autoplay=1", allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture", allowFullScreen: true }))
    },
    {
        width: "4.6%",
        height: "13%",
        left: "63.6%",
        top: "64%",
        label: "IBM - Cost of a Data breach fulll report 2022",
        target: "_blank",
        href: "https://assets.swoogo.com/uploads/2182236-636a7e604cf08.pdf",
        isExternal: true
    },
    {
        width: "4.6%",
        height: "13%",
        left: "68.6%",
        top: "64%",
        label: "IBM - X-Force Cloud Threat Landscape 2022",
        target: "_blank",
        href: "https://assets.swoogo.com/uploads/2182237-636a7e92510b0.pdf",
        isExternal: true
    },
    {
        width: "6.6%",
        height: "13%",
        left: "67.6%",
        top: "16%",
        label: "IBM - Play Demo",
        modalOverrides: modalOverrides,
        modal: React.createElement("div", { style: { height: "100%", width: "100%" } },
            React.createElement("iframe", { width: "100%", height: "100%", frameBorder: "0", src: "https://player.vimeo.com/video/764990463?h=479b81720e&autoplay=1", allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture", allowFullScreen: true }))
    },
    {
        width: "17.6%",
        height: "10%",
        left: "77.6%",
        top: "21%",
        label: "IBM - Social Media",
        modalOverrides: textModal(),
        modal: sponsorModal("Booth 2", "IBM", React.createElement(React.Fragment, null, "IBM Security offers one of the most advanced and integrated portfolios of enterprise security products and services. The portfolio, supported by world-renowned IBM Security X-Force\u00AE research, enables organisations to effectively manage risk and defend against emerging threats. IBM Security operates one of the world\u2019s broadest security research, development and delivery organisations, monitors 150 billion+ security events per day in more than 130 countries, and has been granted more than 10,000 security patents worldwide. For more information, please check https://www.ibm.com/security, follow IBM Security\u202F@IBMSecurity\u202Fon Twitter or visit the\u202FIBM Security Intelligence\u202Fblog."), {
            company: "https://www.ibm.com/security"
        })
    },
];
